<template>
  <div
    class="consent-banner"
    aria-modal="true"
    :aria-label="$t('cookieConsent.main.title')"
    data-qe-id="consent-banner"
  >
    <t-container>
      <div id="consentBannerDescription" class="description">{{ $t('cookieConsent.footer.text') }}</div>
      <div class="buttons" ref="accept-all-button">
        <t-button class="accept-all" @click="onAcceptClick" midGreen data-qe-id="button-accept">{{
          $t('cookieConsent.footer.button_accept_all')
        }}</t-button>
        <t-button class="settings" @click="onSettingsClick" yellow data-qe-id="button-settings">{{
          $t('cookieConsent.footer.button_2')
        }}</t-button>
        <t-text center class="link-reject">
          <a @click="onRejectAll" href="#">
            {{ $t('cookieConsent.footer.button_accept_none') }}
          </a>
        </t-text>
      </div>
    </t-container>
  </div>
</template>

<script setup lang="ts">
import { onMounted, useTemplateRef } from 'vue'
import { ACTION } from '@gd/tracking'
import { postSettings } from '../lib/request'
import { track } from '../lib/track'
import { events } from '@gd/event-bus'

const emit = defineEmits(['on-settings', 'close'])
const acceptAllButton = useTemplateRef('accept-all-button')

onMounted(() => {
  track({
    id: 'consent_banner',
    action: ACTION.show,
  })
  if (acceptAllButton.value) (acceptAllButton.value.firstChild as HTMLButtonElement)?.focus()
})

function onAcceptClick() {
  post({ functional: true, marketing: true })
  track({
    id: 'consent_banner',
    elem: 'button_consent_all',
    action: ACTION.click,
  })
}

function onSettingsClick() {
  emit('on-settings')
  track({
    id: 'consent_banner',
    elem: 'button_visit_settings',
    action: ACTION.click,
  })
}

function onRejectAll(e: Event) {
  e.stopPropagation()
  e.preventDefault()
  post({ functional: false, marketing: false })
  track({
    id: 'consent_banner',
    elem: 'button_reject_all',
    action: ACTION.click,
  })
}

function post(data: { functional: boolean; marketing: boolean }) {
  postSettings(data)
    .then(() => {
      events.$emit('cookie-consent', data)
      emit('close')
    })
    .catch(() => {
      emit('close')
    })
}
</script>

<style lang="less"></style>
